import { render, staticRenderFns } from "./ShippingMethodsSelect.vue?vue&type=template&id=18342565&scoped=true"
import script from "./ShippingMethodsSelect.vue?vue&type=script&lang=js"
export * from "./ShippingMethodsSelect.vue?vue&type=script&lang=js"
import style0 from "./ShippingMethodsSelect.vue?vue&type=style&index=0&id=18342565&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18342565",
  null
  
)

export default component.exports